import { BtnStyleTypes } from "libraries/ui_button/btn.component";
import { Component, Input, OnInit } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import {
    ICoupon,
    ISectorAir,
    ISectorStay,
    ITicket,
    TGetBookingResponse,
} from "libraries/service/resources/booking/interfaces/IGetBookings";
import { IWenji } from "libraries/interfaces/IWenji";
import {
    IRulesSearchFormOutput
} from "libraries/component/sectors-air-details-list/components/rules-search-form/rules-search-form.component";
import { AirTicketResourceService } from "libraries/service/resources/air-ticket-resource/air-ticket-resource.service";
import { ILoader } from "libraries/component/loader/ILoader";
import { INotification, NotificationType } from "libraries/interfaces/INotification";
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";

import {
    RateInBookingType,
    ResponseForConvertTicketAfx2jsonType,
    RuleType,
    SectorInTicketType,
    SectorXRefType
} from "@afidium/ts-facade";
import {
    IRuleTypeWithSectorCoupon,
    ISectorArrayWithCoupon
} from "libraries/component/sectors-air-details-list/sectors-air-details-list.component";
import { faAngleDown, faAngleUp, faArrowRight, faTicketAlt, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { EAirBookingPermissions } from "libraries/component/booking-information/e-air-booking-permissions.enum";
import { PriceType } from "libraries/component/price/price.component";
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";

declare const wenji: IWenji;

class Wording {
    public readonly noTicketInfo: string = Yii.t('wui-shared-js', 'Aucune information billet');
    public readonly noTicketNumber: string = Yii.t('wui-shared-js', 'Numéro de billet inconnu');
    public readonly when: string = Yii.t('wui-shared-js', 'Émis le');
    public readonly searchRules: string = Yii.t('wui-shared-js', 'Recherche des rêgles tarifaires');
    public readonly newSearchRules: string = Yii.t('wui-shared-js', 'Nouvelle recherche des règles tarifaires');
    public readonly issued: string = Yii.t('wui-shared-js', 'Total émis :');
    public readonly used: string = Yii.t('wui-shared-js', 'Valeur consommée :');
    public readonly pending: string = Yii.t('wui-shared-js', 'Valeur restante :');
}

@Component({
    selector: 'booking-traveller-ticket',
    template: `
        <div class="no-information" *ngIf="!ticket?.length; else hasTicket">{{wording.noTicketInfo}}</div>
        <ng-template #hasTicket>
            <div class="ticket-container" *ngFor="let ticketData of ticket; let i = index; trackBy: trackByFn">
                <div class="ticket-abstract cols" (click)="toggle(i)">
                    <div class="icon">
                        <fa-icon [icon]="iconTicket"></fa-icon>
                    </div>
                    <div class="info">
                        <strong *ngIf="ticketData.number"> {{ticketData.number}} </strong>

                        <span *ngIf="!ticketData.number"> {{wording.noTicketNumber}}</span>

                        <div *ngIf="ticketData?.whenIssued?.date">
                            {{wording.when}} {{ticketData.whenIssued.date | dateMoment : dateFormat}}
                        </div>
                    </div>

                    <div class="collapser" *ngIf="ticketData.sectorArray && ticketData.price">
                        <fa-icon [icon]="visible[i] ? iconAngleUp : iconAngleDown"></fa-icon>
                    </div>

                    <ng-container *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_SHOW"
                                  class="prices-container">
                        <div class="price-container" *ngIf="ticketData.price?.total">
                            <div class="price">
                                <div class="price-label">
                                    {{wording.issued}}
                                </div>
                                <div class="price-content">
                                    <price [value]="ticketData.price.total.issuedValue"
                                           [currency]="ticketData.price.total.currency"
                                           [type]="priceTypeBold"
                                           [allowZeroValue]="true"></price>
                                </div>

                            </div>
                            <div class="price"
                                 *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_HISTORY_SHOW">
                                <div class="price-label">
                                    {{wording.used}}
                                </div>
                                <div class="price-content">
                                    <price [value]="ticketData.price.total.usedValue"
                                           [currency]="ticketData.price.total.currency"
                                           [type]="priceType"
                                           [allowZeroValue]="true"></price>
                                </div>
                            </div>
                            <div class="price"
                                 *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_HISTORY_SHOW">
                                <div class="price-label">
                                    {{wording.pending}}
                                </div>
                                <div class="price-content">
                                    <price [value]="ticketData.price.total.pendingValue"
                                           [currency]="ticketData.price.total.currency"
                                           [type]="priceType"
                                           [allowZeroValue]="true"></price>
                                </div>
                            </div>
                        </div>

                    </ng-container>


                </div>


                <ng-container>
                    <div class="form" *ngIf="fareRuleSearchPermission">
                        <div class="rules-actions">
                            <btn [value]="isSearchSuccess ? wording.newSearchRules : wording.searchRules"
                                 [type]="btnType.actionLink"
                                 (onClick)="visibleRules[i] = !visibleRules[i]">
                                <fa-icon class="icon-end"
                                         [icon]="visibleRules[i] ? iconAngleUp : iconAngleDown"></fa-icon>
                            </btn>
                        </div>
                        <div class="rules-form" *ngIf="visibleRules[i]">
                            <loader *ngIf="loader.active" [message]="loader.message"></loader>
                            <notification *ngIf="notification.active"
                                          [type]="notification.type">{{notification.message}}</notification>
                            <rules-search-form [hidden]="loader.active"
                                               [whenIssued]="ticketData.whenIssued?.date"
                                               (onSubmit)="launchTicketSearch($event, i)"></rules-search-form>
                        </div>
                    </div>

                </ng-container>

                <div class="ticket-detail" *ngIf="ticketData.sectorArray?.length && ticketData.price">
                    <sectors-air-details-list [sectors]="ticketData.sectorArray"
                                              [detail]="ticketData.price.detail"
                                              [allVisible]="visible[i]"
                                              [ruleArray]="ruleArray"
                                              (onChangeAllVisible)="changeVisible($event, i)">
                    </sectors-air-details-list>
                </div>

            </div>
        </ng-template>
    `,
    styleUrls: ['./booking-traveller-ticket.component.scss']
})
export class BookingTravellerTicketComponent implements OnInit {
    @Input()
    public ticket: ITicket[];
    @Input()
    public sector: Array<ISectorAir | ISectorStay>;
    @Input()
    public host: string;

    public readonly wording: Wording = new Wording();

    public readonly dateFormat: string = JSON.parse(wenji.ui.dateFormat).momentShort;

    public fullSector: Array<Array<ISectorAir | ISectorStay>> = [];

    public btnType: typeof BtnStyleTypes = BtnStyleTypes;

    public visible: boolean[] = [];
    public visibleRules: boolean[] = [];
    public isSearchSuccess: boolean = false;

    public loader: ILoader = {
        active: false,
        message: Yii.t('wui-shared-js', 'Recherche en cours')
    };

    public notification: INotification = {
        active: false,
        message: Yii.t('wui-shared-js', 'Erreur lors de la recherche des notes tarifaires.'),
        type: NotificationType.Error,
    };

    public ruleArray: IRuleTypeWithSectorCoupon[];

    public fareRuleSearchPermission: boolean;

    public airBookingPermissions: typeof EAirBookingPermissions = EAirBookingPermissions;
    public iconTicket: IconDefinition = faTicketAlt;
    public iconAngleDown: IconDefinition = faAngleDown;
    public iconAngleRight: IconDefinition = faArrowRight;
    public iconAngleUp: IconDefinition = faAngleUp;

    public priceType: PriceType = PriceType.light;
    public priceTypeBold: PriceType = PriceType.default;

    constructor(
        private readonly airTicketResourceService: AirTicketResourceService,
        private readonly errorTracingService: ErrorTracingService,
        private readonly permissionResourceService: PermissionResourceService,
    ) {
    }

    public ngOnInit(): void {
        this.permissionResourceService
            .hasPermissionWithRestriction(
                this.airBookingPermissions.SHARED_AIR_BOOKING_DETAIL_FARE_RULES_SEARCH,
                ({host: this.host} as unknown as TGetBookingResponse)
            )
            .subscribe((fareRuleSearchPermission: boolean): void => {
                this.fareRuleSearchPermission = fareRuleSearchPermission;
            });
    }

    public toggle(index: number): void {
        this.visible[index] = !this.visible[index];
    }

    public trackByFn(index: number): number {
        return index;
    }

    public changeVisible(visible: boolean, index: number): void {
        this.visible[index] = visible;
    }

    public launchTicketSearch(formOutput: IRulesSearchFormOutput, ticketIndex: number): void {
        this.loader.active = true;
        this.notification.active = false;
        const ticketNumber: string = this.ticket[ticketIndex].number;
        this.airTicketResourceService
            .search(
                {
                    ...formOutput,
                    ticketNumber
                }
            )
            .subscribe({
                next: (ticketResponse: ResponseForConvertTicketAfx2jsonType): void => {

                    this.loader.active = false;

                    const rate: RateInBookingType = ticketResponse?.ticket?.price?.cost?.detail?.rate;

                    if (!Boolean(rate)) {
                        this.notification = {
                            ...this.notification,
                            active: true,
                            message: Yii.t('wui-shared-js', 'Erreur lors de la récupération des tarifs.'),
                        };
                    } else {
                        this.ruleArray = rate ? rate.ruleArray
                            .map((rule: RuleType): IRuleTypeWithSectorCoupon => {
                                return {
                                    ...rule,
                                    sectorArrayWithCoupon: rate.sectorArray.map((sector: SectorXRefType): ISectorArrayWithCoupon => {
                                        const relatedSector: SectorInTicketType = ticketResponse.ticket.sectorArray
                                            .find((fullSector: SectorInTicketType): boolean => fullSector.xId === sector.xRef);
                                        return {
                                            ...sector,
                                            couponArray: relatedSector.couponArray,
                                        };
                                    })
                                };
                            }) : null;
                        this.visibleRules[ticketIndex] = false;
                        this.visible[ticketIndex] = true;
                        this.isSearchSuccess = true;
                    }

                },
                error: (error: Error): void => {
                    this.loader.active = false;
                    this.notification = {
                        ...this.notification,
                        message: error.message,
                        active: true,
                    };
                    this.errorTracingService.captureException(error);
                }
            });
    }
}
